import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import PaymentsTable from "./paymentsTable";
import Pagination from "../../components/common/pagination";
import { getPayments, getCounters } from "../../services/paymentService";
import SearchBox from "../../components/searchBox";
import CounterCards from "../../components/common/countercards";
import LoadingIndicator from "../../components/common/LoadingIndicator";

class Payments extends Component {
  state = {
    payments: [],
    currentPage: 1,
    pageSize: 10,
    searchQuery: "",
    sortColumn: { path: "id", order: "desc" },
    // FIXME: Move status to centralized location
    status: [
      { id: 0, label: "New", value: 0 },
      { id: 1, label: "Paid", value: 1 },
      { id: 2, label: "Completed", value: 2 },
      { id: 3, label: "Canceled", value: 3 },
    ],
    cards: [
      {
        path: "current_day",
        name: "Today (₦)",
        number: "",
        icon: <i className="fa fa-code-fork" />,
        background: "primary"
      },
      {
        path: "current_week",
        name: "This Week (₦)",
        number: "",
        icon: <i className="fa fa-ticket" />,
        background: "danger"

      },
      {
        path: "current_month",
        name: "This Month (₦)",
        number: "",
        icon: <i className="fa fa-database" />,
        background: "success"
      },
      {
        path: "current_year",
        name: "This Year (₦)",
        number: "",
        icon: <i className="fa fa-users" />,
        background: "info"
      },
    ],
    loading: true,
    totalCount: 0,
  };

  formatDate(date) {
    let formatted = "";
    if (!date) return formatted;

    const momentDate = moment(date);
    if (!momentDate.isValid()) return formatted;

    formatted = momentDate.format("Do MMM. YYYY").toString();
    return formatted;
  }

  async populateCounters() {
    // const { data: counters } = await getCounters();
    // const Cards = this.state.cards.map(obj => {
    //   let Number = counters.find(c => c.name === obj.path).number;
    //   // Number = new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN", maximumFractionDigits: 0 }).format(Number);
    //   return {...obj, 
    //     number: Number,
    //   };
    // });
    // this.setState({ cards: Cards });  
  }

  async componentDidMount() {
    await this.populatePayments();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.state?.refreshToken !== this.props.location?.state?.refreshToken) {
      this.setState({
        currentPage: 1,
        searchQuery: "",
        sortColumn: { path: "id", order: "desc" },
        loading: true,
      }, () => {
        this.populatePayments();
      });
    }
  }

  populatePayments = async () => {
    try {
      if (!this.state.loading) this.setState({ loading: true });

      const { currentPage, pageSize, searchQuery, sortColumn } = this.state;

      const params = {
        page: currentPage,
        pageSize,
        sortBy: sortColumn.path,
        sortOrder: sortColumn.order.toUpperCase(),
      };
      if (searchQuery) params.search = searchQuery;

      const response = await getPayments(params);
      const payload = response?.data;
      const payments = Array.isArray(payload) ? payload : (payload?.data || []);
      const totalCount = Array.isArray(payload) ? payments.length : (payload?.pagination?.totalCount || 0);

      const Payments = payments.map(obj => {
        return {
          ...obj,
          id: obj.id,
          paid: this.formatDate(obj.paid),
          transid: obj.transid,
          account: obj.account,
          amount: Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN" }).format(obj.amount),
        };
      });

      this.setState({ payments: Payments, totalCount, loading: false });
    } catch (ex) {
      console.error('Error fetching payments:', ex);
      toast.error('Failed to load payments');
      this.setState({ loading: false });
    }
  };

  handleLike = payment => {
    const payments = [...this.state.payments];
    const index = payments.indexOf(payment);
    payments[index] = { ...payments[index] };
    payments[index].liked = !payments[index].liked;
    this.setState({ payments });
  };

  handlePageChange = page => {
    this.setState({ currentPage: page, loading: true }, this.populatePayments);
  };

  handleGenreSelect = genre => {
    this.setState({ selectedGenre: genre, searchQuery: "", currentPage: 1 });
  };

  handleSearch = query => {
    this.setState({ searchQuery: query, selectedGenre: null, currentPage: 1, loading: true }, this.populatePayments);
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn, loading: true }, this.populatePayments);
  };

  render() {
    const { pageSize, currentPage, sortColumn, searchQuery } = this.state;
    const { user } = this.props;

    const { payments, totalCount } = this.state;

    return (
      <React.Fragment>
        {/* <CounterCards cards={this.state.cards} />
        <hr className="m-3" /> */}
        <div className="row">
          <div className="col">
            <div>
              <div className="pull-right">
                {user && (
                  <Link
                    to="/payments/new"
                    className="btn btn-primary btn-sm"
                    style={{ marginBottom: 20 }}
                  >
                    <i className="fa fa-plus-circle" /> New Payment
                  </Link>
                )}
              </div>
              {this.state.loading && <LoadingIndicator message="Loading payments..." />}
              {!this.state.loading &&
              <div>
                <p>You have {totalCount ? totalCount : "no"} transaction{(totalCount > 1 || totalCount === 0) && "s"}.</p>
              </div>}
            </div>
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
            <PaymentsTable
              payments={payments}
              filters={{ searchQuery, sortColumn }}
              sortColumn={sortColumn}
              onLike={this.handleLike}
              onSort={this.handleSort}
            />
            <Pagination
              itemsCount={totalCount}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={this.handlePageChange}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Payments;